import React, { useState } from 'react';
import axios from '../utils/axiosInstance';
import { useNavigate } from 'react-router-dom';
import './AuthForm.css';

const Register = () => {
  const [form, setForm] = useState({
    username: '',
    password: '',
    displayName: '', // NEW
    bio: '',
    image: null,
  });
  const [preview, setPreview] = useState(null);
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleImageChange = (e) => {
    const file = e.target.files?.[0] || null;
    setForm({ ...form, image: file });

    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => setPreview(reader.result);
      reader.readAsDataURL(file);
    } else {
      setPreview(null);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSubmitting(true);

    try {
      const formData = new FormData();
      formData.append('username', form.username);
      formData.append('password', form.password);
      formData.append('displayName', form.displayName || ''); // NEW
      formData.append('name', form.displayName || '');        // NEW (for backends that use "name")
      formData.append('bio', form.bio || '');
      if (form.image) {
        // Field name MUST be "image" to match multer.single('image')
        formData.append('image', form.image);
      }

      await axios.post('/auth/register', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });

      alert('✅ Registration successful! Please log in.');
      // Go to the auth landing that shows LOGIN / REGISTER tabs.
      // If your tabs live at '/auth', change '/' to '/auth'.
      navigate('/');
    } catch (err) {
      console.error('Registration error:', err);
      if (err.response?.status === 409) {
        setError('That username is already taken.');
      } else {
        setError('Registration failed. Please try again.');
      }
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-form-container">
        <h2 className="welcome-header">Welcome to Rankr</h2>

        {error && <p className="error-message">{error}</p>}

        {preview ? (
          <img src={preview} alt="Preview" className="image-preview" />
        ) : (
          <div className="image-placeholder" />
        )}

        <form onSubmit={handleSubmit} encType="multipart/form-data">
          <input
            type="text"
            name="username"
            placeholder="Username"
            value={form.username}
            onChange={handleChange}
            required
          />
          <input
            type="password"
            name="password"
            placeholder="Password"
            value={form.password}
            onChange={handleChange}
            required
          />
          {/* NEW: Display Name (right below password) */}
          <input
            type="text"
            name="displayName"
            placeholder="Name (how it appears on your profile)"
            value={form.displayName}
            onChange={handleChange}
          />
          <textarea
            name="bio"
            placeholder="Tell us about yourself"
            value={form.bio}
            onChange={handleChange}
            rows={3}
          />

          {/* Custom Upload button + hidden input */}
          <input
            id="reg-image"
            type="file"
            accept="image/*"
            onChange={handleImageChange}
            className="visually-hidden"
          />
          <label htmlFor="reg-image" className="btn upload-btn">Upload Image</label>

          <button type="submit" disabled={submitting}>
            {submitting ? 'Creating…' : 'Register'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Register;
